var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sigle-route"}},[_c('h1',[_vm._v(_vm._s(this.testEmail))]),_c('article')])
}
var staticRenderFns = []

export { render, staticRenderFns }